<template>
  <div class="home">
    <modal
      height="auto"
      classes="msg-modal"
      width="300px"
      :adaptive="true"
      name="message"
      >{{ msg }}</modal
    >
    <div>
      <div class="chains">
        <div
          v-for="(c, index) in chains"
          v-bind:key="index"
          :class="['chain-item', chain === c ? 'active' : '']"
          @click="switchChain(c)"
        >
          <i :class="['icon-chain', c]"></i>
          <span> {{ c.toUpperCase() }} </span>
        </div>
      </div>

      <span class="profile" v-if="currentAddress">
        {{ currentAddress.substr(0, 6) }}...{{
          currentAddress.substr(-4)
        }}</span
      >
      <span class="login-btn" v-else @click="login()">Connect</span>
    </div>

    <div class="cards card-wrap">
      <h2>TP New Year Series NFT (Card)</h2>
      <img
        @click="preview('card', img)"
        v-for="(img, index) in cards"
        v-bind:key="index"
        :src="img"
        alt=""
      />
      <div class="claim-wrap">
        <p>Available: {{ 2022 - mintedCard }} / 2022</p>
        <p>
          <button disabled v-if="mintedCard >= 2022">Finished</button>
          <button v-else @click="mint('card')">Mint</button>
        </p>
      </div>
    </div>
    <div class="bgs card-wrap">
      <h2>TP New Year Series NFT (Background)</h2>
      <img
        @click="preview('bg', img)"
        v-for="(img, index) in bgs"
        v-bind:key="index"
        :src="img"
        alt=""
      />
      <div class="claim-wrap">
        <p>Available: {{ 2022 - mintedBg }} / 2022</p>
        <button disabled v-if="mintedBg >= 2022">Finished</button>
        <button v-else @click="mint('bg')">Mint</button>
      </div>
    </div>

    <div class="more card-wrap">
      More details visit:
      <a href="https://twitter.com/TokenPocket_TP" target="_blank"
        >TokenPocket 2022 New Year Event</a
      >
    </div>
  </div>
</template>

<script>
import {
  CardContract,
  BgContract,
  ABI,
  NodeMap,
  ChainIdMap,
  IdChainMap,
} from "../constants";
import Web3 from "web3";
// @ is an alias to /src
import HelloWorld from "@/components/HelloWorld.vue";
// import VConsole from "vconsole";

// var vc = new VConsole();

const NftSeries = [];

export default {
  name: "home",
  components: {
    HelloWorld,
  },
  data() {
    return {
      msg: "",
      // left: 2022,
      chains: ["eth", "bsc", "heco", "ftm"],
      chain: "",
      currentAddress: "",
      cards: [
        "https://tp-statics.tokenpocket.pro/NFT/2022Newyear/card1.png",
        "https://tp-statics.tokenpocket.pro/NFT/2022Newyear/card2.png",
        "https://tp-statics.tokenpocket.pro/NFT/2022Newyear/card3.png",
        "https://tp-statics.tokenpocket.pro/NFT/2022Newyear/card4.png",
        "https://tp-statics.tokenpocket.pro/NFT/2022Newyear/card5.png",
        "https://tp-statics.tokenpocket.pro/NFT/2022Newyear/card6.png",
        "https://tp-statics.tokenpocket.pro/NFT/2022Newyear/card7.png",
      ],
      bgs: [
        "https://tp-statics.tokenpocket.pro/NFT/2022Newyear/bg1.png",
        "https://tp-statics.tokenpocket.pro/NFT/2022Newyear/bg2.png",
        "https://tp-statics.tokenpocket.pro/NFT/2022Newyear/bg3.png",
        "https://tp-statics.tokenpocket.pro/NFT/2022Newyear/bg4.png",
        "https://tp-statics.tokenpocket.pro/NFT/2022Newyear/bg5.png",
        "https://tp-statics.tokenpocket.pro/NFT/2022Newyear/bg6.png",
        "https://tp-statics.tokenpocket.pro/NFT/2022Newyear/bg7.png",
      ],
      mintedBg: 0,
      mintedCard: 0,
    };
  },
  created() {},
  mounted() {
    if (navigator.userAgent.indexOf("TokenPocket") > -1) {
      setTimeout(() => {
        this.login();
      }, 1000);
    } else {
      this.login();
    }

    if (window.ethereum) {
      ethereum.on("accountsChanged", (account) => {
        this.login();
      });

      ethereum.on("chainChanged", (network) => {
        this.login();
      });
    }
  },
  methods: {
    showMsg(msg) {
      this.msg = msg;
      this.$modal.show("message");
    },
    preview(type, imgSrc) {},
    async mint(type) {
      if (!window.ethereum) {
        this.showMsg("Open in TokenPocket");
        return;
      }

      if (!this.currentAddress) {
        await this.login();
      }

      if (Number(window.ethereum.chainId) !== ChainIdMap[this.chain]) {
        await this.switchChain();
      }

      let contract = "";
      if (type === "card") {
        contract = CardContract;
      } else if (type === "bg") {
        contract = BgContract;
      } else {
        this.showMsg("Not support");
        return;
      }

      let web3 = new Web3(window.ethereum);
      let instance = new web3.eth.Contract(ABI, contract);
      let gas = "";

      try {
        gas = await instance.methods
          .mint()
          .estimateGas({ from: this.currentAddress });
      } catch (err) {
        if (err.message.indexOf("Coming soon") > -1) {
          this.showMsg("Not start yet");
        } else if (err.message.indexOf("already minted") > -1) {
          this.showMsg("Already minted");
        } else if (err.message.indexOf("Better luck next time") > -1) {
          this.showMsg("All NFT has been minted");
        } else {
          this.showMsg(err.message);
        }
        console.log(err);
      }

      if (!gas) {
        return;
      }

      instance.methods
        .mint()
        .send({ from: this.currentAddress })
        .on("transactionHash", (hash) => {
          this.showMsg("Submitted");
        })
        .on("receipt", (receipt) => {
          this.showMsg("Success!");
        })
        .on("error", (err) => {
          this.showMsg(err);
        });
    },
    async login() {
      if (window.ethereum) {
        try {
          let accounts = await ethereum.request({
            method: "eth_requestAccounts",
          });

          this.currentAddress = accounts[0].toLowerCase();
          this.chain = IdChainMap[Number(ethereum.chainId)];

          setTimeout(() => {
            this.queryLeft();
          }, 2000);
        } catch (err) {
          console.log(err);
        }
      }
    },
    async queryLeft() {
      let web3 = new Web3(window.ethereum);
      try {
        let CardInstance = new web3.eth.Contract(ABI, CardContract);
        let BgInstance = new web3.eth.Contract(ABI, BgContract);

        this.mintedCard = await CardInstance.methods.circulationSupply().call();
        this.mintedBg = await BgInstance.methods.circulationSupply().call();
      } catch (err) {
        console.log(err);
      }
    },
    async switchChain(chain) {
      let chainId = "0x" + ChainIdMap[chain || this.chain].toString(16);

      try {
        await ethereum.request({
          method: "wallet_switchEthereumChain",
          params: [{ chainId }],
        });

        this.login();
      } catch (switchError) {
        // This error code indicates that the chain has not been added to MetaMask.
        if (switchError.code === 4902) {
          try {
            await ethereum.request({
              method: "wallet_addEthereumChain",
              params: [
                {
                  chainId,
                  chainName: this.chain.toUpperCase(),
                  rpcUrls: [NodeMap[this.chain]],
                },
              ],
            });
          } catch (addError) {
            // handle "add" error
          }
        }
        // handle other "switch" errors
      }

      if (navigator.userAgent.indexOf("TokenPocket") > -1) {
        setTimeout(() => {
          location.reload(true);
        }, 1000);
      }
    },
  },
};
</script>

<style scoped lang="less">
.home {
  width: 100%;
  max-width: 480px;
  margin: 0 auto;

  .login-btn,
  .profile {
    float: right;
    padding: 2px 12px;
    display: inline-block;
    vertical-align: middle;
    margin: 12px auto 8px;
    border-radius: 8px;
    line-height: 24px;
  }

  .login-btn {
    background-color: #007bff;
    color: #fff;
  }

  .profile {
    background-color: #f1f1f1;
  }
  .more {
    padding: 24px 0 !important;
    text-align: center;

    a {
      color: #007bff;
      text-decoration: none;
    }
  }

  h2 {
    font-size: 16px;
    margin: 12px 0;
    padding: 0 0 0 8px;
    line-height: 1.2;
    border-left: 4px solid #007bff;
  }

  .card-wrap {
    padding: 8px;
    background-color: #fff;
    margin: 12px 0;
    border-radius: 8px;
    box-shadow: 0 0 8px 0 #ddd;
  }

  .claim-wrap {
    text-align: center;
    margin: 24px 0;

    button {
      padding: 8px 24px;
      background-color: #007bff;
      color: #fff;
      border: none;
      border-radius: 4px;

      &:disabled {
        background-color: #ddd;
      }
    }
  }

  .chains {
    display: inline-block;

    margin: 12px auto 8px;
    border-radius: 8px;
    overflow: hidden;

    .chain-item {
      background-color: #eee;
      display: inline-block;
      vertical-align: middle;
      font-size: 14px;
      line-height: 24px;
      padding: 2px 8px;
      cursor: pointer;

      &.active {
        background-color: #007bff;
        color: #fff;
      }

      i,
      span {
        display: inline-block;
        vertical-align: middle;
      }

      .icon-chain {
        width: 16px;
        height: 16px;
        background-size: 100% 100%;
        margin-right: 4px;

        &.eth {
          background-image: url(../assets/chains/eth.svg);
        }
        &.bsc {
          background-image: url(../assets/chains/bsc.svg);
        }
        &.heco {
          background-image: url(../assets/chains/heco.svg);
        }
        &.ftm {
          background-image: url(../assets/chains/fantom.svg);
        }
      }
    }
  }

  .cards {
    img {
      width: 48%;
      margin: 4px 1%;
    }
  }

  .bgs {
    img {
      width: 24%;
      margin: 4px 0.5%;
    }
  }
}

@media screen and (max-width: 380px) {
  .home {
    .chains {
      .chain-item {
        padding: 2px 4px;
        font-size: 13px;

        .icon-chain {
          width: 14px;
          height: 14px;
        }
      }
    }

    .profile {
      font-size: 13px;
    }
  }
}
</style>
